export const TYPE_COVER = 'cover';
export const TYPE_CHAPTER = 'chapter';
export const TYPE_CHAPTERS = 'chapters';
